"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchesTablePage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var delete_branch_1 = require("../../../../../api/calls/branch/delete/delete_branch");
var constants_1 = require("../../../../../constants/constants");
var pages_1 = require("../../../../../constants/pages");
var routes_1 = require("../../../../../constants/routes");
var permissions_1 = __importDefault(require("../../../../../hooks/permissions"));
var useSearchDebounce_1 = require("../../../../../hooks/useSearchDebounce");
var IUser_1 = require("../../../../../interfaces/IUser");
var branch_1 = require("../../../../../reducers/slices/branch/branch");
var branch_list_thunk_1 = require("../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var toggle_branch_status_thunk_1 = require("../../../../../reducers/slices/branch/thunks/updates/toggle_branch_status_thunk");
var main_1 = require("../../../../../reducers/slices/main");
var client_user_selector_1 = require("../../../../../selectors/client_user_selector");
var branch_filter_control_1 = require("./components/branch_filter_control");
var constants_2 = require("./constants");
var constants_3 = require("../../../constants");
var BranchesTablePage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(1100), searchString = _a[0], setSearchString = _a[1];
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }), branches = _b.branches, pagination = _b.pagination, isLoading = _b.isLoading;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var _c = (0, react_1.useState)(undefined), offline = _c[0], setOffline = _c[1];
    var _d = (0, react_1.useState)(false), showFilters = _d[0], setShowFilters = _d[1];
    var _e = (0, react_1.useState)(undefined), branchHasDelivery = _e[0], setBranchHasDelivery = _e[1];
    var branchesPermissions = (0, permissions_1.default)(IUser_1.IPermissions.BRANCHES);
    var _f = (0, react_redux_1.useSelector)(client_user_selector_1.isManagerSelector), isManager = _f.isManager, branchIdList = _f.managedBanches;
    var branch_id_list = branchIdList === null || branchIdList === void 0 ? void 0 : branchIdList.join(",");
    var query = __assign(__assign({ offline: offline, delivery: branchHasDelivery }, (searchString && { search_string: searchString })), (isManager && { branch_id_list: branch_id_list }));
    (0, react_1.useEffect)(function () {
        if ((user === null || user === void 0 ? void 0 : user._id) && (client === null || client === void 0 ? void 0 : client._id)) {
            _getBranchList({ showLoader: !searchString });
        }
    }, [user, client, searchString]);
    var _getBranchList = function (params) {
        if (params === void 0) { params = {}; }
        return dispatch((0, branch_list_thunk_1.branch_list_thunk)(__assign(__assign(__assign({}, pagination), query), params)));
    };
    var _onToggleBranch = function (offline) {
        setOffline(offline);
        _getBranchList({ offline: offline });
    };
    var onDeleteBranch = function (data) {
        dispatch((0, main_1.setContentModal)({
            title: "Confirm",
            content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Are you sure you want to delete this branch ".concat(data.display_name, "?"), textColor: "text-inputText" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-slate-300", textColor: "text-dark", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Continue", size: "small", onClick: function () { return _deleteBranch(data); } })] }))),
        }));
    };
    var _deleteBranch = function (data) {
        (0, delete_branch_1.branch_delete)({ _id: data._id }).then(function (response) {
            if (response.success) {
                dispatch((0, main_1.setContentModal)(null));
                _getBranchList();
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: constants_1.REQUEST_ERROR_TITLE, messages: [response.message] }));
            }
        });
    };
    var rowActions = [
        branchesPermissions.canView && {
            label: "View",
            onClick: function (data) {
                dispatch((0, branch_1.setSelectedBranch)(constants_2.initialBranchData));
                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.BRANCHES_ROUTE).concat(routes_1.BRANCH_DETAILS_ROUTE, "/").concat(data === null || data === void 0 ? void 0 : data._id));
            },
        },
        branchesPermissions.canUpdate && {
            label: "Status",
            onClick: function (data) {
                dispatch((0, toggle_branch_status_thunk_1.toggle_branch_status_thunk)({
                    branch_id: data === null || data === void 0 ? void 0 : data._id,
                    branch_status: !(data === null || data === void 0 ? void 0 : data.offline),
                }));
            },
        },
        branchesPermissions.canDelete && {
            label: "Delete",
            onClick: onDeleteBranch,
        },
    ].filter(Boolean);
    var onPageChange = function (page) {
        _getBranchList({
            page: page,
        });
    };
    var onRowsPerPageChange = function (size) {
        _getBranchList({
            size: size,
        });
    };
    var _onToggleDelivery = function (delivery) {
        setBranchHasDelivery(delivery);
        _getBranchList({ delivery: delivery });
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faSlidersSimple, size: "small", backgroundColor: "bg-primary", iconColor: "text-white", onClick: function () { return setShowFilters(!showFilters); } }), showFilters && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Online", value: offline === undefined ? false : !offline, onButtonClick: function () { return _onToggleBranch(false); } }), (0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Offline", value: offline, onButtonClick: function (v) { return _onToggleBranch(true); } }), (0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Delivery", value: branchHasDelivery, onButtonClick: _onToggleDelivery })] })))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: branchesPermissions.canCreate && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Add Branch", backgroundColor: "bg-success", endIcon: pro_light_svg_icons_1.faPlus, size: "small", onClick: function () {
                                        dispatch((0, branch_1.setSelectedBranch)(constants_2.initialBranchData));
                                        navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.BRANCHES_ROUTE).concat(routes_1.BRANCH_DETAILS_ROUTE));
                                    } })) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Search", endIcon: pro_light_svg_icons_1.faSearch, size: "small", onChange: setSearchString })] }))] })), isLoading ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "grid justify-center p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl //
                , { size: "xlarge" }) }))) : ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { data: branches, columns: [
                    {
                        displayKey: "branch_number",
                        label: "Branch number",
                    },
                    {
                        displayKey: "display_name",
                        label: "Name",
                    },
                    {
                        displayKey: "contact_number",
                        label: "Phone",
                    },
                    {
                        displayKey: "email",
                        label: "Email",
                    },
                    {
                        displayKey: "total",
                        label: "Total Revenue",
                        formatter: function (o) {
                            var _a;
                            if (o) {
                                if (o.branch_revenue) {
                                    return doshx_controls_web_1.Utilities.formatMoney({
                                        symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                                        value: (_a = o === null || o === void 0 ? void 0 : o.branch_revenue) === null || _a === void 0 ? void 0 : _a.total,
                                        symbolSeparation: true,
                                    });
                                }
                            }
                            else {
                                return doshx_controls_web_1.Utilities.formatMoney({
                                    symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                                    value: "0",
                                    symbolSeparation: true,
                                });
                            }
                        },
                    },
                    {
                        displayKey: "average",
                        label: "Average revenue",
                        formatter: function (o) {
                            var _a;
                            if (o) {
                                if (o.branch_revenue) {
                                    return doshx_controls_web_1.Utilities.formatMoney({
                                        symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                                        value: (_a = o === null || o === void 0 ? void 0 : o.branch_revenue) === null || _a === void 0 ? void 0 : _a.average,
                                        symbolSeparation: true,
                                    });
                                }
                            }
                            else {
                                return doshx_controls_web_1.Utilities.formatMoney({
                                    symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                                    value: "0",
                                    symbolSeparation: true,
                                });
                            }
                        },
                    },
                    {
                        displayKey: "delivery.delivery",
                        label: "Delivery",
                        formatter: function (o) {
                            var value = "No";
                            if (o) {
                                if (o.delivery) {
                                    if (o.delivery.delivery === false) {
                                        value = "No";
                                    }
                                    else {
                                        value = "Yes";
                                    }
                                }
                                return value;
                            }
                            return "";
                        },
                    },
                    {
                        displayKey: "offline",
                        label: "Status",
                        formatter: function (o) {
                            var value = "";
                            if (o) {
                                if (o.offline === true || o.offline == undefined) {
                                    value = "Offline";
                                }
                                else {
                                    value = "Online";
                                }
                                return (0, constants_3.TABLE_STATUSES)(value);
                            }
                            return "";
                        },
                    },
                ], rowActions: rowActions, hasShadow: true, pagination: {
                    currentPage: pagination.page,
                    rowsPerPage: pagination.size,
                    totalRecords: pagination.countTotal,
                    onPageChange: onPageChange,
                    onRowsPerPageChange: onRowsPerPageChange,
                }, colors: pages_1.tableColorConfig }))] })));
};
exports.BranchesTablePage = BranchesTablePage;
